import axios from "axios"
import config from "../data/config.json"

export default async function getUserRewards(identifier, address) {
    const response = await axios.get(`${config.apiUrl}/get-user-rewards?identifier=${identifier}&address=${address}`)
    return response.data
}
